// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Ocorrencias_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for save() /ocorrencias/save
 * Returns the created occurrence record from the Go microservice.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Ocorrencias_SaveResponseDados {
ID?: string
Owner?: string
OwnerID?: number
User?: string
Content?: string
CreatedAt?: string
}

export type Ocorrencias_SaveResponse = ApiResponse<Ocorrencias_SaveResponseDados>;

registerResponseContract('Ocorrencias_SaveResponse', {
  ID:        { type: 'string',  required: false },
  Owner:     { type: 'string',  required: false },
  OwnerID:   { type: 'number',  required: false },
  User:      { type: 'string',  required: false },
  Content:   { type: 'string',  required: false },
  CreatedAt: { type: 'string',  required: false },
})
